import React, { useState, useMemo, useEffect } from 'react'
import { Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'
import WidgetGenericStatistic from 'components/global/Widgets/WidgetGenericStatistic'

import { useNavigate } from 'router'
import { DashboardRange, Queues } from '../components/Filters'
import { DateRange } from '../components/Filters/DashboardRange'
import PhoneNumbers from './PhoneNumbers'
import ReportCDRs from './ReportCDRs'
import Graph from './Graph'
import { useKpis, useStats } from './use-queries'
import { parseDate} from './utils'

const KPIS: React.FC = () => {
  const { kpis, loading} = useKpis()
  const {t} = useTranslation()
  const navigate = useNavigate()
  return (
    <Stack spacing={2}>
      <WidgetGenericStatistic
        loading={loading}
        title={t('voip.phone_numbers.kpis_administrative')}
        positionTooltip={{x: -120}}
        nbWarning={kpis?.administrative_down}
        nbSuccess={kpis?.administrative_up}
        onClick={(status) => {
          navigate({ pathname: '/voip/sips', search: `?filter_status=${status}&filter_type=administrative` })
        }}
        nbError={0}
        total={kpis?.administrative_down + kpis?.administrative_up}
        sx={{
          width: '100%',
        }}
      />
      <WidgetGenericStatistic
        loading={loading}
        onClick={(status) => {
          navigate({ pathname: '/voip/sips', search: `?filter_status=${status}&filter_type=room` })
        }}
        title={t('voip.phone_numbers.kpis_rooms')}
        positionTooltip={{x: -120}}
        nbWarning={kpis?.room_down}
        nbSuccess={kpis?.room_up}
        nbError={0}
        total={kpis?.room_down + kpis?.room_up}
        sx={{
          width: '100%',
        }}
      />
    </Stack>
  )
}

const Dashboard: React.FC = () => {
  const [dateRange, setDateRange] = useState<DateRange>(DateRange.Today)
  const [queue, setQueue] = useState<string>()
  const [availableQueues, setAvailableQueues] = useState([])
  const { startAt, endAt } = useMemo(() => parseDate(dateRange), [dateRange])
  const {stats, loading} = useStats({
    startAt,
    endAt,
    queue,
    scale: endAt.diff(startAt, 'day') === 0 ? 'hour' : 'day'
  })
  useEffect(() => {
    if (!queue && stats?.queue_names) {
      setAvailableQueues(stats.queue_names)
    }
  }, [queue, stats])

  const hasData = stats && (stats.count_call_success > 0 || stats.count_call_failure > 0)

  return (
    <Stack spacing={2}>
      <Stack direction={'row'} alignItems={'center'}>
        <Stack direction={'row'} gap={1} height={'100%'}>
          <DashboardRange
            value={dateRange}
            onChange={({ value }) => {
              setDateRange(value)
              setQueue(undefined)
            }}
          />
          <Queues
            value={queue} onChange={(value) => setQueue(value)}
            names={availableQueues}
          />
        </Stack>
      </Stack>
      <Stack direction={'row'} spacing={2}>
        <Stack flex={1} gap={3}>
          <Graph dateRange={dateRange} stats={stats} loading={loading} />
          <PhoneNumbers  />
        </Stack>
        <Stack sx={{width: '340px'}} gap={3}>
          <ReportCDRs stats={stats} loading={loading} />
          {hasData && <KPIS />}
        </Stack>
      </Stack>

    </Stack>

  )
}

export default Dashboard